import React from 'react';
import {useIntl} from 'react-intl';
import {percentualize} from '../../../services/dashboardUtils';
import {fillChartOptions} from '../../../utils/analytics';
import FullscreenChart from './FullscreenChart';

const buildBarColumnChartOptions = (type, config, data, hints, intl) => {
    const sum = data.series.map((s) => s.values.reduce((a, b) => a + b, 0));

    return fillChartOptions({
        chart: {
            type,
        },
        legend: {enabled: false},
        xAxis: {
            categories: data.categories,
            title: {enabled: false, text: config.title},
        },
        yAxis: {
            title: {enabled: false},
        },
        series: data.series.map((s, i) => ({
            data: s.values.map((value) => percentualize(value, sum[i], hints)),
            name: s.name,
            dataLabels: {
                enabled: true,
                format: hints.absolute ? '{point.y:f}' : '{point.y:.0f}%',
            },
        })),
        tooltip: {
            formatter: function() {
                return `${this.x}: ${this.y}${hints.absolute ? '' : '%'}`;
            },
        },
        plotOptions: {
            series: {
                colorByPoint: true,
                colors: ['#E8617F', '#F9C717', '#119BD6'],
            },
        },
    }, config, data, hints, intl);
};

const buildNpsOptions = (config, data, hints, intl) => {
    const total = data.series[0].values.reduce((a, b) => a + b, 0);
    const detractors = (data.series[0].values[0]) / total * 100;
    const promoters = (data.series[0].values[2]) / total * 100;
    const score = Math.floor(promoters - detractors);

    const options = fillChartOptions({
        chart: {
            type: 'solidgauge',
        },
        legend: {enabled: false},
        pane: {
            center: ['50%', '85%'],
            // size: '100%',
            startAngle: -90,
            endAngle: 90,
            background: {
                innerRadius: '60%',
                outerRadius: '100%',
                shape: 'arc',
            },
        },
        yAxis: {
            min: -100,
            max: 100,
            title: {text: 'Net Promoter Score', y: -70},
            lineWidth: 0,
            tickWidth: 0,
            minorTickInterval: null,
            tickAmount: 2,
            labels: {y: 16},
        },
        series: data.series.map((s, i) => ({
            data: [score],
            name: s.name,
            dataLabels: {
                enabled: true,
                format: '<span style="font-size:25px">{y}</span>',
            },
        })),
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            solidgauge: {
                dataLabels: {
                    y: 5,
                    borderWidth: 0,
                    useHTML: true,
                },
            },
        },
    }, config, data, hints, intl);
    return options;
};

const buildOptions = buildBarColumnChartOptions.bind(undefined, 'column');

const GeneratorNpsWidget = ({data, params, hints}) => {
    const intl = useIntl();
    if (params.type === 'nps') {
        return <FullscreenChart hints={hints} options={buildNpsOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />;
    }
    return <FullscreenChart hints={hints} options={buildOptions(params, data, hints, intl)} customLabel={`n=${data.count}`} />;
};

export default GeneratorNpsWidget;
